<template>
  <section>
    <div :style="{width: '100%', height: '400px'}" ref="chart"></div>
  </section>

</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'ECharts',
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  mounted() {
    this.chart = echarts.init(this.$refs.chart);
    this.chart.setOption(this.options);
  },
  watch: {
    options: {
      deep: true,
      handler(newOptions) {
        this.chart.setOption(newOptions);
      }
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/EChart.vue